import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import ShoppingBasket from "../../../common/assets/icons/shoppingBasket.png";
import { $SiteColors } from "../../../common/config/company-atts";
import "../styles/GroupServicesTopBar.css";


interface IServicesTopBar {
  setShowBasket: React.Dispatch<React.SetStateAction<boolean>>;
  serviceCount: number;
  title: string
}

export const ServicesTopBar = ({serviceCount, title, setShowBasket}: IServicesTopBar) => {  
  const [scount, setCount] = useState(serviceCount)
  const [hideBasketBtn, setHideBasketBtn] = useState(true)
  useEffect(() => {
    setCount(serviceCount)
    if(serviceCount == 0) {
      setHideBasketBtn(true)
      setShowBasket(false)
    } else {
      setHideBasketBtn(false)
    }
  }, [serviceCount])
  return (
    <div className="gstb_main_con">
      <div className="gstb_title">{title}</div>
      <Button onClick={() => setShowBasket(true)} hidden={hideBasketBtn} variant="default" className="gstb_btn_set_show_basket" style={{ background: $SiteColors.getState().backBtnSubmit }} >
        <div className="row col-12 m-0 p-0">
          <img className="p-2 m-auto" src={ShoppingBasket} style={{maxWidth: "40px"}} />
          <div className="mt-auto mb-auto ml-0 mr-auto">Корзина</div>
          <hr style={{transform: "rotate(90deg)", background: "white", margin: "auto", paddingRight: "0.5rem", paddingLeft: "0.5rem"}} />
          <span className="m-auto" >{serviceCount} усл.</span>
        </div>
      </Button>
    </div>
  );
};
